import {AxiosResponse} from 'axios'
import {ReprocessAlbumRequest, ReprocessAlbumResponse} from './types'
import {HttpInstance} from '../createHttpInstance'

export interface ReprocessAlbumFaces<P, R> {
  (http: HttpInstance, params: P): Promise<AxiosResponse<R>>
}

// Re-runs facial-recognition tagging for a whole album by asking the photos
// service to re-list the album's photos and re-emit a domain.photo.create per
// photo (the ReprocessPhotoTaggingForAlbum operation). The faces service's
// photo-created consumer then re-runs recognition per photo. This is the
// on-demand recovery path for albums whose publish back-fill silently dropped
// photos before they were tagged. It does NOT re-publish the album (no family
// "album published" re-notification) and does not touch CM Facial Recognition.
export const reprocessAlbumFaces: ReprocessAlbumFaces<
  ReprocessAlbumRequest,
  ReprocessAlbumResponse
> = (http, params) => {
  const {ClientID, AlbumID} = params

  const path = '/v1/photos/reprocess'

  return http.request<ReprocessAlbumResponse>({
    method: 'POST',
    url: `${path}?albumid=${AlbumID}&clientid=${ClientID}`,
  })
}
